import http from '@/assets/js/common/http-common';

class TestDataService {
  
  list(data = null) {
    return http.post('prova/list', data);
  }

  create(data) {
    return http.post('prova/create', data);
  }

  read(id) {
    return http.post('prova/read', {id:id});
  }

  update(data) {
    return http.post('prova/update', data);
  }
  
  delete(id) {
    return http.post('prova/delete', {id:id});
  }

  createClassroom(data) {
    return http.post('prova/createClassroom', data);
  }

  deleteGroup(id, groupId) {
    return http.post('prova/deleteGroup', {id:id, groupId:groupId});
  }
  
  deleteStudent(id, userId) {
    return http.post('prova/deleteStudent', {id:id, userId:userId});
  }

  activeStatus() {
    return http.post('prova/activeStatus', null);
  }

  isTestActivated() {
    return http.post('prova/isTestActivated', null);
  }

  listGroups(id) {
    return http.post('prova/listGroups', {id:id});
  }

  listGroupsTest(id) {
    return http.post('prova/listGroupsTest', {id:id});
  }

  listStudents(id) {
    return http.post('prova/listStudents', {id:id});
  }

  listStudentsTest(id) {
    return http.post('prova/listStudentsTest', {id:id});
  }

  studentsTest(id) {
    return http.post('prova/studentsTest', {id:id});
  }

  studentDashboard(data = null) {
    return http.post('prova/studentDashboard', data);
  }

}

export default new TestDataService();
